import { mdiChevronRight } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, ButtonBase, Typography } from '@mui/material';

interface ButtonProps {
  icon: string;
  text: string;
  description: string;
  onClick: () => void;
  sensitive?: boolean;
}

export default function ButtonTransferencia({
  icon,
  text,
  description,
  onClick,
  sensitive = false
}: ButtonProps) {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        alignItems: 'center',
        border: '1px solid',
        borderColor: sensitive ? '#F6D3D8' : '#CADAF4',
        borderRadius: 1.5,
        display: 'flex',
        gap: { xs: 1.25, sm: 1.5 },
        minHeight: { xs: 76, sm: 84 },
        px: { xs: 1.5, sm: 2 },
        py: 1.5,
        textAlign: 'left',
        width: '100%',
        '&:hover': { borderColor: sensitive ? '#CF343C' : '#1873DC' },
        '&.Mui-focusVisible': { outline: '2px solid #1873DC', outlineOffset: 2 }
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: sensitive ? '#FFF0F2' : '#EAF2FF',
          borderRadius: 1.5,
          color: sensitive ? '#C9343C' : '#176ED5',
          display: 'flex',
          flexShrink: 0,
          height: { xs: 48, sm: 56 },
          justifyContent: 'center',
          width: { xs: 48, sm: 56 }
        }}
      >
        <Icon path={icon} size={1} />
      </Box>
      <Box flex={1} minWidth={0}>
        <Typography color="#17234D" fontSize={{ xs: 16, sm: 18 }} fontWeight={700}>
          {text}
        </Typography>
        <Typography color="#6B7890" fontSize={{ xs: 13, sm: 14 }} lineHeight={1.4} mt={0.25}>
          {description}
        </Typography>
      </Box>
      <Box color="#68778F" display="flex" flexShrink={0}>
        <Icon path={mdiChevronRight} size={0.8} />
      </Box>
    </ButtonBase>
  );
}
